import React, { useState } from "react";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { PATHS } from "config/paths";
import { useTranslation } from "react-i18next";

const AlertMessage = ({ user, isWithBank }) => {
  console.log("🚀 ~ AlertMessage ~ isWithBank:", !isWithBank);
  const { t } = useTranslation(); // <-- ajout i18n
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(isWithBank ? !isWithBank : true);

  const handleClose = () => setIsVisible(false);
  if (!isVisible) return null;

  return (
    <div className="alert-message">
      {/* Header */}
      <div className="alert-header">
        <div className="header-content">
          <div className="alert-icon">💳</div>
          <h3 className="alert-title">{t("alert.title")}</h3>
        </div>
        <button onClick={handleClose} className="close-button">
          ×
        </button>
      </div>

      {/* Content */}
      <div className="alert-content">
        <p className="greeting">
          {t("alert.greeting")}{" "}
          <strong>{user?.name || t("alert.user_default")}</strong>,
        </p>

        <div className="feature-section">
          <p className="feature-title">{t("alert.feature_title")}</p>
          <p className="feature-description">
            {t("alert.feature_description")} <strong>INVOICIA</strong> :
          </p>
          <ul className="feature-list">
   
            <li>🧾 {t("alert.feature_2")}</li>
           
          </ul>
        </div>

        {/* Requirements Section */}
        <div className="requirements-section">
          <p className="requirements-title">{t("alert.requirements_title")}</p>
          <div className="requirements-list">
            <div className="requirement-item">• {t("alert.req_bank_name")}</div>
            <div className="requirement-item">• {t("alert.req_iban")}</div>
            <div className="requirement-item">• {t("alert.req_bic")}</div>
            <div className="requirement-item">• {t("alert.req_address")}</div>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="alert-actions">
        <button
          onClick={() => {
            navigate(PATHS.CONFIGURATION);
            handleClose();
          }}
          className="primary-button">
          💳 {t("alert.add_button")}
        </button>

        <button onClick={handleClose} className="secondary-button">
          {t("alert.remind_later")}
        </button>
      </div>

      {/* Footer */}
      <div className="alert-footer">{t("alert.footer")}</div>
    </div>
  );
};

export default AlertMessage;
